require("-!style!css!./../node_modules/vue-loader/lib/selector.js?type=style&index=0!./Aside.vue")
module.exports = require("-!babel?optional[]=runtime!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Aside.vue")
module.exports.template = require("-!vue-html!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Aside.vue")



/*****************
 ** WEBPACK FOOTER
 ** ./src/Aside.vue
 ** module id = 86
 ** module chunks = 0
 **/